import React from "react";
import { connect } from "react-redux";
import Layout from "../components/layout/layout";
import "../assets/css/base.css";
import * as actions from "../actions";
import { parseFooterItems } from "../constants/parse/banners";

class LayoutHOC extends React.Component {
  render() {
    const { history, location, footerItems } = this.props;
    return (
      <Layout
        history={history}
        location={location.pathname}
        footerItems={footerItems}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  footerItems: parseFooterItems(state.general?.footerItems),
});

export default connect(mapStateToProps)(LayoutHOC);
